import React, { Suspense } from 'react'
import { Button, ModalBody, ModalFooter, ModalHeader, Progress } from 'reactstrap'
import Modal from 'src/components/theme/Models/Modal'
import Body from './Body'
import { Eeocs } from 'src/queries'

interface indexProps {
  data: Eeocs[0] | undefined
  isOpen: boolean
  toggle: () => void
}

const index: React.FC<indexProps> = (props) => {
  const { data, isOpen, toggle } = props
  if (data === undefined) {
    return null
  }
  return (
    <Modal
      title='EEOC Paperwork Data'
      isOpen={isOpen}
      toggle={() => toggle()}
    >
      <ModalHeader toggle={() => toggle()}>EEOC Paperwork Data</ModalHeader>
      <Suspense fallback={<ModalBody><Progress animated>Loading...</Progress></ModalBody>}>
        <Body data={data} />
      </Suspense>
      <ModalFooter>
        <Button color='secondary' onClick={() => toggle()}>Close</Button>
      </ModalFooter>
    </Modal>
  )
}

export default index
